import React from 'react'
import { ProtectedPage } from '~/src/components/templates'
import { useTranslation } from 'react-i18next'
import { OrderStatementOfAccountDetailForm } from '~/src/components/organisms/StatementOfAccount/StatementOfAccountDetail/OrderStatementDetailForm'

export const OrderStatementOfAccountCreate: React.VFC = (): JSX.Element => {
  const { t } = useTranslation()

  return (
    <ProtectedPage pageTitle={t('statement_account_detail.title2')}>
      {/*@ts-ignore*/}
      <OrderStatementOfAccountDetailForm />
    </ProtectedPage>
  )
}
